
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"icon",attrs:{"fill":"#C5C5C5","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 3.545l1.214 1.213a10.254 10.254 0 017.303-3.042A10.258 10.258 0 0115.8 4.739l1.213-1.216A11.97 11.97 0 008.517 0C5.187 0 2.174 1.356 0 3.545z"}}),_c('path',{attrs:{"d":"M8.517 4.288a7.689 7.689 0 00-5.484 2.29L4.247 7.79a5.982 5.982 0 014.27-1.786c1.66 0 3.165.676 4.252 1.768l1.213-1.213a7.691 7.691 0 00-5.465-2.274v.003zm0 4.288c-.962 0-1.828.396-2.45 1.034l2.43 2.432 2.452-2.45a3.415 3.415 0 00-2.432-1.017v.001z"}})])])
          )
        }
      }
    